import React from 'react';
import { useLocation, useParams } from 'react-router-dom';

export const withRouter = (Component) => {
  return (props) => (
    <Component
      {...props}
      location={useLocation()}
      match={{ params: useParams() }}
    />
  );
};
